<script setup lang="ts">
import type { Tone } from '@/lib/presentation'

defineProps<{
	tone: Tone
	label: string
	/** Shows a spinner in the pill while the check is still running. */
	pending?: boolean
}>()
</script>

<template>
	<span class="pill" :class="`tone-${tone}`">
		<span v-if="pending" class="spinner-border" aria-hidden="true" />
		{{ label }}
	</span>
</template>

<style scoped>
.pill {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	flex: none;
	padding: 3px 12px;
	border: 1px solid var(--tone-border);
	border-radius: 999px;
	background: var(--tone-bg);
	color: var(--tone-fg);
	font-size: 0.8125rem;
	font-weight: 500;
	white-space: nowrap;
}

.spinner-border {
	width: 0.7rem;
	height: 0.7rem;
	border-width: 2px;
}
</style>
